import { ITest } from "./Intarfaces/ITest";

export default [
    {
        id:0,
        question:"1. Какой из перечисленных документов является основным международным актом, регулирующим права инвалидов, в том числе в сфере труда?",
        answers:[
            {
                id:0,
                text:'1. Всеобщая декларация прав человека',
                isTrue:false

            },
            {
                id:1,
                text:'2. Международный пакт об экономических, социальных и культурных правах',
                isTrue:false

            },
            {
                id:2,
                text:'3. Конвенция ООН о правах инвалидов',
                isTrue:true

            },
            {
                id:3,
                text:'4. Европейская социальная хартия',
                isTrue:false

            },
        ]
    }, 
    {
        id:1,
        question:"2. Какой из следующих видов реабилитации включает в себя медицинскую помощь и восстановление функций организма?",
        answers:[
            {
                id:0,
                text:'1. Психологическая реабилитация',
                isTrue:false

            },
            {
                id:1,
                text:'2. Социальная реабилитация',
                isTrue:false

            },
            {
                id:2,
                text:'3. Профессиональная реабилитация',
                isTrue:false

            },
            {
                id:3,
                text:'4. Медицинская реабилитация',
                isTrue:true

            },
            {
                id:4,
                text:'5. Образовательная реабилитация',
                isTrue:false

            },
        ]
    }, 
    {
        id:2,
        question:"3. Какое из следующих утверждений о адаптивной физической культуре является правильным?",
        answers:[
            {
                id:0,
                text:'1. Адаптивная физическая культура предназначена только для людей с физическими ограничениями.',
                isTrue:false

            },
            {
                id:1,
                text:'2. Адаптивная физическая культура включает адаптацию физических упражнений для людей с различными потребностями.',
                isTrue:true

            },
            {
                id:2,
                text:'3. Адаптивная физическая культура не учитывает индивидуальные особенности участников.',
                isTrue:false

            },
            {
                id:3,
                text:'4. Адаптивная физическая культура не имеет научной основы.',
                isTrue:false

            },
            {
                id:4,
                text:'5. Адаптивная физическая культура доступна только в специализированных учреждениях.',
                isTrue:false

            },
        ]
    }, 
    {
        id:3,
        question:"4. Какой из следующих аспектов является ограничением адаптивной физической культуры?",
        answers:[
            {
                id:0,
                text:'1. Ограниченный доступ к оборудованию и специальным программам.',
                isTrue:true
            },
            {
                id:1,
                text:'2. Широкий выбор видов спорта и активности.',
                isTrue:false

            },
            {
                id:2,
                text:'3. Наличие квалифицированных тренеров.',
                isTrue:false

            },
            {
                id:3,
                text:'4. Поддержка со стороны общественных организаций.',
                isTrue:false

            },
            {
                id:4,
                text:'5. Разнообразие методов тренировок.',
                isTrue:false

            },
        ]
    }, 
    {
        id:4,
        question:"5. Какой из следующих принципов является ключевым в адаптивной физической культуре?",
        answers:[
            {
                id:0,
                text:'1. Игнорирование индивидуальных потребностей участников.',
                isTrue:false

            },
            {
                id:1,
                text:'2. Применение универсальных методов для всех без исключения.',
                isTrue:false

            },
            {
                id:2,
                text:'3. Индивидуальный подход к каждому участнику в зависимости от его возможностей и потребностей.',
                isTrue:true

            },
            {
                id:3,
                text:'4. Обеспечение равного доступа только для людей с физическими ограничениями.',
                isTrue:false

            },
            {
                id:4,
                text:'5. Сосредоточение исключительно на соревнованиях и результатах.',
                isTrue:false

            },
        ]
    }, 
    {
        id:5,
        question:"6. Какой из следующих способов может помочь поддерживать мотивацию к физической активности?",
        answers:[
            {
                id:0,
                text:'1. Участие в групповых занятиях или клубах по интересам.',
                isTrue:true

            },
            {
                id:1,
                text:'2. Полное отсутствие общения с другими людьми.',
                isTrue:false

            },
            {
                id:2,
                text:'3. Изоляция от общественных мероприятий и активностей.',
                isTrue:false

            },
            {
                id:3,
                text:'4. Сравнение себя с другими, которые имеют более высокие достижения.',
                isTrue:false

            },
            {
                id:4,
                text:'5. Игнорирование прогресса и успехов в занятиях.',
                isTrue:false

            },
        ]
    }, 
    {
        id:6,
        question:"7. Характеристики, присущие психологически зрелой личности ",
        answers:[
            {
                id:0,
                text:'1. Оптимизм, смелость, импульсивность',
                isTrue:false

            },
            {
                id:1,
                text:'2 Потребность во власти, стремление к любви, оптимизм',
                isTrue:false

            },
            {
                id:2,
                text:'3. Оптимизм, уравновешенность, ответственность',
                isTrue:true

            },
            {
                id:3,
                text:'4. Знание психологических закономерностей, мудрость, стремление к безопасности',
                isTrue:false

            },
        ]
    }, 
    {
        id:7,
        question:"8. Наличие конкретной цели у личности повышает ее … ",
        answers:[
            {
                id:0,
                text:'1. Уровень развития коммуникативных навыков',
                isTrue:false

            },
            {
                id:1,
                text:'2. Мотивацию и самооценку',
                isTrue:false

            },
            {
                id:2,
                text:'3. Качество жизни',
                isTrue:false

            },
            {
                id:3,
                text:'4. Мотивацию и результаты деятельности',
                isTrue:true

            },
        ]
    }, 
    {
        id:8,
        question:"9. Что такое психологическое благополучие в контексте позитивной психологии?",
        answers:[
            {
                id:0,
                text:'1. Отсутствие психических расстройств.',
                isTrue:false

            },
            {
                id:1,
                text:'2. Субъективное ощущение удовлетворенности жизнью, включающее автономию, личностный рост и позитивные отношения.',
                isTrue:true

            },
            {
                id:2,
                text:'3. Способность зарабатывать деньги.',
                isTrue:false

            },
            {
                id:3,
                text:'4. Физическое здоровье без болезней.',
                isTrue:false

            },
        ]
    }, 
    {
        id:9,
        question:"10. Что понимается под жизнеспособностью?",
        answers:[
            {
                id:0,
                text:'1. Способность быстро бегать.',
                isTrue:false

            },
            {
                id:1,
                text:'2. Способность адаптироваться к стрессу, преодолевать трудности и восстанавливаться после неудач.',
                isTrue:true

            },
            {
                id:2,
                text:'3. Умение игнорировать проблемы.',
                isTrue:false

            },
            {
                id:3,
                text:'4. Финансовая устойчивость.',
                isTrue:false

            },
        ]
    }, 
    {
        id:10,
        question:"11. Какой фактор способствует развитию жизнеспособности у человека?",
        answers:[
            {
                id:0,
                text:'1. Избегание социальных связей.',
                isTrue:false

            },
            {
                id:1,
                text:'2. Постоянный стресс без перерыва.',
                isTrue:false

            },
            {
                id:2,
                text:'3. Поддержка от семьи и друзей.',
                isTrue:true

            },
            {
                id:3,
                text:'4. Игнорирование эмоций.',
                isTrue:false

            },
        ]
    }, 
    {
        id:11,
        question:"12. Что понимается под понятием «универсальный дизайн» в контексте инклюзивного пространства?",
        answers:[
            {
                id:0,
                text:'1. Дизайн, призванный сделать предметы и среду пригодными для использования всеми людьми без необходимости адаптации.',
                isTrue:true

            },
            {
                id:1,
                text:'2. Эксклюзивное проектирование объектов для комфортного использования людьми с инвалидностью.',
                isTrue:false

            },
            {
                id:2,
                text:'3. Стандартизация всех объектов инфраструктуры под нужды маломобильных групп.',
                isTrue:false

            },
            {
                id:3,
                text:'4. Дизайн, ориентированный исключительно на эстетическую привлекательность общественных пространств.',
                isTrue:false

            },
        ]
    }, 
    {
        id:12,
        question:"13. Какая модель инвалидности, согласно презентации, доминировала в России исторически и фокусировалась на диагнозе и изоляции человека?",
        answers:[
            {
                id:0,
                text:'1. Социальная модель',
                isTrue:false

            },
            {
                id:1,
                text:'2. Медицинская модель',
                isTrue:true

            },
            {
                id:2,
                text:'3. Экономическая модель',
                isTrue:false

            },
            {
                id:3,
                text:'4. Психологическая модель',
                isTrue:false

            },
        ]
    }, 
    {
        id:13,
        question:"14. Какой из перечисленных инструментов используется для обеспечения информационной доступности для глухих и слабослышащих людей?",
        answers:[
            {
                id:0,
                text:'1. Тактильная плитка',
                isTrue:false

            },
            {
                id:1,
                text:'2. Тифлокомментирование',
                isTrue:false

            },
            {
                id:2,
                text:'3. Индукционные петли',
                isTrue:true

            },
            {
                id:3,
                text:'4. Шрифт Брайля',
                isTrue:false

            },
        ]
    }, 
    {
        id:14,
        question:"15. Какие ключевые направления составляют основную структуру инклюзивной медиаповестки?",
        answers:[
            {
                id:0,
                text:'1. Искусство, спорт, экономика, образование, политика, искусство и культура, туризм, здравоохранение, досуг и развлечения, наука и технологии, право',
                isTrue:false

            },
            {
                id:1,
                text:'2. Образование, социальная жизнь, искусство и культура, здоровье и медицина, администрирование и управление, досуг и развлечения, наука и технологии, право',
                isTrue:true

            }
        ]
    }, 
    {
        id:15,
        question:"16. Какая тематическая область лидирует среди категорий проблем, затрагиваемых в рамках инклюзивной повестки?",
        answers:[
            {
                id:0,
                text:'1. Политика',
                isTrue:false

            },
            {
                id:1,
                text:'2. Социальная жизнь',
                isTrue:false

            },
            {
                id:2,
                text:'3. Здоровье и медицина',
                isTrue:false

            },
            {
                id:3,
                text:'4. Образование',
                isTrue:true

            },
        ]
    }, 
    {
        id:16,
        question:"17. Размер квоты для приема на работу инвалидов на предприятиях, у которых численность работников превышает свыше 35 человек, установлен в размере: ",
        answers:[
            {
                id:0,
                text:'1. от 1 до 3%;',
                isTrue:false

            },
            {
                id:1,
                text:'2. от 2 до 4%;',
                isTrue:true

            },
            {
                id:2,
                text:'3. от 3 до 5%;',
                isTrue:false

            },
            {
                id:3,
                text:'4. от 5 до 10%.',
                isTrue:false

            },
        ]
    }, 
    {
        id:17,
        question:"18. Какую сумму государство компенсирует на организацию рабочего места на предприятии для инвалидов: ",
        answers:[
            {
                id:0,
                text:'1. до 100 тыс. рублей;',
                isTrue:false

            },
            {
                id:1,
                text:'2. до 200 тыс. рублей;',
                isTrue:true

            },
            {
                id:2,
                text:'3. до 300 тыс. рублей;',
                isTrue:false

            },
            {
                id:3,
                text:'4. до 500 тыс. рублей.',
                isTrue:false

            },
        ]
    }, 
    {
        id:18,
        question:"19. При трудоустройстве инвалидов со стороны работодателей приоритет отдается:",
        answers:[
            {
                id:0,
                text:'1. инвалидам по ОПА;',
                isTrue:false

            },
            {
                id:1,
                text:'2. инвалидам по зрению и слуху;',
                isTrue:false

            },
            {
                id:2,
                text:'3. инвалидам по нарушениям интеллектуального спектра;',
                isTrue:false

            },
            {
                id:3,
                text:'4. приоритет отсутствует.',
                isTrue:true

            },
        ]
    }, 
    {
        id:19,
        question:"20. Какие организации освобождаются от обязанности соблюдения квоты для приема на работу инвалидов?",
        answers:[
            {
                id:0,
                text:'1. Государственные организации.',
                isTrue:false

            },
            {
                id:1,
                text:'2. Организации с численностью работников менее 100 человек.',
                isTrue:false

            },
            {
                id:2,
                text:'3. Организации, занимающиеся особо опасными видами деятельности.',
                isTrue:false

            },
            {
                id:3,
                text:'4. Организации с численностью работников менее 35 человек.',
                isTrue:true

            },
        ]
    }, 
    {
        id:20,
        question:"21. Что понимается под специальными условиями труда для инвалидов?",
        answers:[
            {
                id:0,
                text:'1. Льготный режим рабочего времени и отдыха.',
                isTrue:false

            },
            {
                id:1,
                text:'2. Оборудование рабочего места в соответствии с индивидуальной программой реабилитации инвалида.',
                isTrue:false

            },
            {
                id:2,
                text:'3. Предоставление дополнительных отпусков.',
                isTrue:false

            },
            {
                id:3,
                text:'4. Все перечисленные варианты.',
                isTrue:true

            },
        ]
    }, 
    {
        id:21,
        question:"22. Кто несет ответственность за создание специальных условий труда для инвалида?",
        answers:[
            {
                id:0,
                text:'1. Работодатель.',
                isTrue:true

            },
            {
                id:1,
                text:'2. Органы службы занятости.',
                isTrue:false

            },
            {
                id:2,
                text:'3. Организации, проводящие реабилитацию инвалидов.',
                isTrue:false

            },
            {
                id:3,
                text:'4. Работодатель и органы службы занятости совместно.',
                isTrue:false

            },
        ]
    }, 
    {
        id:22,
        question:"23. Некоммерческие организации для инвалидов в России: ",
        answers:[
            {
                id:0,
                text:'1. могут распределять полученную прибыль на нужны учредителей-инвалидов;',
                isTrue:false

            },
            {
                id:1,
                text:'2. имеют право на налоговые льготы;',
                isTrue:true

            },
            {
                id:2,
                text:'3. могут создаваться только под эгидой государственных органов или крупных корпораций;',
                isTrue:false

            },
            {
                id:3,
                text:'4. должны быть членами соответствующих профилю международных организаций, в том числе созданных в рамках ООН.',
                isTrue:false

            },
        ]
    },  
    {
        id:23,
        question:"24. Инклюзивное образование, согласно ФЗ «Об образовании в РФ» (от 29.12.2012 г. №273-ФЗ), это:",
        answers:[
            {
                id:0,
                text:'1. создание оптимальных условий для социализации для детей с ОВЗ и инвалидностью',
                isTrue:false

            },
            {
                id:1,
                text:'2. создание оптимальных условий для нравственного развития нормально развивающихся детей',
                isTrue:false

            },
            {
                id:2,
                text:'3.  обеспечение равного доступа к образованию для всех обучающихся с учетом разнообразия особых образовательных потребностей и индивидуальных возможностей',
                isTrue:true

            }
        ]
    }, 
] as ITest[]